import { render, staticRenderFns } from "./lotto.vue?vue&type=template&id=4fa527c2&scoped=true&"
import script from "./lotto.vue?vue&type=script&lang=js&"
export * from "./lotto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa527c2",
  null
  
)

export default component.exports